import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as docketActions from '../../../../redux/actions/docketActions';
import { hasValidClientCode } from '../../../../redux/actions/clientCodeAction';
import Document from './Document';
import AllPartsDocument from './AllPartsDocument';

class Documents extends Component {
  onDownloadZipClick = () => {
    const { case_uuid, court_code, case_number, docket_seq } = this.props;

    const documents = createDocumentParam(court_code, case_number, docket_seq);

    const params = {
      documents
    };

    this.props.getDocketParts({ documents });

    this.props.onPopupClick({
      name: 'DownloadZipAllPdfsRangePopup',
      show: true,
      data: params,
    });
  };

  onDownloadComboPdfClick = () => {
    const { case_uuid, court_code, case_number, docket_seq } = this.props;

    const documents = createDocumentParam(court_code, case_number, docket_seq);

    const params = {
      documents,
      download_option: 1,
    };

    this.props.getDocketParts({documents});

    this.props.onPopupClick({
      name: 'DownloadCombineAllPdfInRangePopup',
      show: true,
      data: params,
    });
  };

  onDownloadEmailZipClick = () => {
    const { case_uuid, court_code, case_number, docket_seq, docket } = this.props;

    const documents = createDocumentParam(court_code, case_number, docket_seq);

    const params = {
      documents,
      download_option: 1,
    };

    this.props.onPopupClick({
      name: 'EmailAllPartsZipPopup',
      show: true,
      data: params,
    });
  };

  onEmailCombinedPdf = () => {
    const { case_uuid, court_code, case_number, docket_seq, docket } = this.props;

    const documents = createDocumentParam(court_code, case_number, docket_seq);

    const params = { documents };

    this.props.onPopupClick({
      name: 'EmailCombinedPdfPopup',
      show: true,
      data: params,
    });
  };

  onAllPartsPrintPreview = () => {
    const { case_uuid, court_code, case_number, docket_seq } = this.props;

    const documents = createDocumentParam(court_code, case_number, docket_seq);

    const params = {
      documents,
      download_option: 1,
    };

    this.props.getDocketParts({ documents });

    this.props.onPopupClick({
      name: 'AllPartsPrintPreview',
      show: true,
      data: params,
    });
  };

  printPreview = document => {
    if (document.preview_url) {
      const win = window.open(document.preview_url);
      if (!/Chrome/.test(navigator.userAgent)) {
        win.print();
      }
    } else {
      // call service to retrieve the preview url
      this.props.orderPdf(document, this.props.docket_seq).then(updatedDocument => {
        window.open(updatedDocument.preview_url);
      });
    }
  };

  emailPartPopup = (friendly_name, sequence_number, part_number) => {
    const { case_uuid, court_code, case_number } = this.props;

    const params = {
      name: 'EmailPartPopup',
      show: true,
      data: {
        case_uuid,
        court_code,
        case_number,
        friendly_name,
        sequence_number,
        part_number,
      },
    };

    this.props.onPopupClick(params);
  };

  emailPartModal = (friendly_name, sequence_number, part_number) => {
    const { case_uuid, court_code, case_number, docket } = this.props;

    const params = {
      name: 'EmailPartModal',
      show: true,
      data: {
        case_uuid,
        court_code,
        case_number,
        friendly_name,
        sequence_number,
        part_number,
        docket,
      },
    };

    this.props.onPopupClick(params);
  };

  downloadFile = document => {
    if (document.download_url) {
      window.open(document.download_url);
    } else {
      // call service to retrieve the download_url
      this.props.orderPdf(document, this.props.docket_seq).then(updatedDocument => {
        window.open(updatedDocument.download_url);
      });
    }
  };

  ocrDownload = document => {
    if (document.ocr_link) {
      window.open(document.ocr_link);
    } else {
      // call service to retrieve the download_url
      this.props.orderPdf(document, this.props.docket_seq).then(updatedDocument => {
        window.open(updatedDocument.ocr_link);
      });
    }
  };

  createBlogPost = document => {
    if (document.blog) {
      window.open(document.blog);
    } else {
      // call service to retrieve the download_url
      this.props.orderPdf(document, this.props.docket_seq).then(updatedDocument => {
        window.open(updatedDocument.blog);
      });
    }
  };

  getPartsInfo = (court_code, case_number, partNumber, sequence_numbers) => {
    const params = { case_docket_sequence_numbers: [{ court_code, case_number, sequence_numbers }] };
    this.props.getPartsPurchaseInfo(params);
  };

  buyPdf = (docket_no, number) => {
    if (this.props.hasValidClientCode()) {
      const { court_code, case_number, docket_seq } = this.props;

      const params = {
        case_no: case_number,
        docket_no,
        number,
        seqNum: docket_seq,
        court_code,
      };

      this.props.buyPdf(params).then(() => this.getPartsInfo(court_code, case_number, number, [docket_seq]));
    }
  };

  render() {
    const { documents } = this.props;

    const allPartsCount = documents.reduce((accum, next) => {
      accum += parseInt(next.pages, 10) || 0;
      return accum;
    }, 0);

    const rows = documents.map((document, index) => (
      <Document
        key={index}
        document={document}
        createBlogPost={this.createBlogPost}
        index={index}
        buyPdf={this.buyPdf}
        ocrDownload={this.ocrDownload}
        downloadFile={this.downloadFile}
        emailPartPopup={this.emailPartPopup}
        emailPartModal={this.emailPartModal}
        printPreview={this.printPreview}
      />
    ));

    if (documents.length > 1) {
      rows.push(
        <AllPartsDocument
          key="all-parts-doc"
          allPartsCount={allPartsCount}
          onDownloadComboPdfClick={this.onDownloadComboPdfClick}
          onDownloadEmailZipClick={this.onDownloadEmailZipClick}
          onEmailCombinedPdf={this.onEmailCombinedPdf}
          onAllPartsPrintPreview={this.onAllPartsPrintPreview}
          onDownloadZipClick={this.onDownloadZipClick}
        />
      );
    }
    return rows;
  }

}

function createDocumentParam(court_code, case_number, ...sequenceNumbers) {
  const documents = sequenceNumbers.map(x => {
    return { court_code, case_number, sequence_number: x }
  });

  return documents;
}

Documents.propTypes = {
  documents: PropTypes.array.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  case_uuid: PropTypes.string.isRequired,
  docket_seq: PropTypes.any.isRequired,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { popup } = state.get('dockets').toJS();

  return {
    popup,
  };
};

const mapDispatchToProps = {
  orderPdf: docketActions.orderPdf,
  buyPdf: docketActions.buyPdf,
  getPartsPurchaseInfo: docketActions.getPartsPurchaseInfo,
  hasValidClientCode,
  getDocketParts: docketActions.getDocketParts,
  onPopupClick: docketActions.togglePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/Documents.jsx